import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VBtn,
    {
      staticClass:
        "document-card rounded overflow-hidden elevation-2 text-center cursor-pointer pa-0 bg-gray-0",
      attrs: {
        text: "",
        "data-qa": "document_card",
        "data-qa-id": _vm.item.id,
        height: "275",
        width: "255",
        ripple: false,
      },
      on: {
        click: function ($event) {
          return _setup.emit("open")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "document-card__body position-relative w-100 h-100" },
        [
          _c(
            "div",
            {
              staticClass:
                "document-card__overlay position-relative w-100 h-100",
            },
            [
              _c("img", {
                staticClass: "document-card__image d-block w-100",
                attrs: {
                  src: _vm.item.previewSrc,
                  alt: _vm.item.alt || _vm.item.title || "",
                  title: _vm.item.title || "",
                  loading: "lazy",
                },
              }),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "document-card__overlay-gradient position-absolute top-0 left-0 w-100 h-100",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "document-card__label position-absolute w-100 text-body-2 text-secondary--text px-4",
            },
            [
              _vm._v("\n      " + _vm._s(_vm.item.title) + "\n      "),
              _c(
                "div",
                {
                  staticClass:
                    "document-card__show-more primary--text mt-2 d-none",
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_setup.t("посмотреть", _setup.options)) +
                      "\n      "
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }